import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import PropTypes from "prop-types";
import { ImSearch } from "react-icons/im";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip, Button, Modal, Form } from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useHasPermission } from "hooks/useHasPermission";
import CrossIcon from "../../../assets/img/file-cut-icon.png";
import { toast, ToastContainer } from "react-toastify";
import api from "../../../services/api";
import { fetchEmployeeList } from "../../../redux/slice/getEmployeeListSlice";
import { updateEmployeeRole } from "../../../redux/slice/updateEmployeeRoleSlice";
import EditRoleModal from "../../../components/common/EditRoleModal";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { fetchSearchData } from "../../../redux/slice/searchDataSlice";
import axiosPrivate from "services/axios/axiosPrivate";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { resendWelcomeMail } from "../../../redux/slice/resendWelcomeMailSlice"
import EditEmpAccountStatusModal from "./EditEmpAccountStatusModal";
import { empAccountStatus, resetEmpAccStatus } from "../../../redux/slice/empAccountStatusSlice";
import { ConfirmAccStatusModal } from "./ConfirmAccStatusModal";

export default function EmployeePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { employees, status } = useSelector((state) => state.employees);
  const searchDataList = useSelector(
    (state) => state.SearchData.SearchDataList,
  );

  const [totalItems, setTotalItems] = useState(employees?.totalItems ?? 0);
  const [totalPages, setTotalPages] = useState(employees?.totalPages ?? 1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [statusCount, setStatusCount] = useState(employees?.statusCount ?? []);
  const [selectedEmpForAccStatus, setSelectedEmpForAccStatus] = useState(null);
  const [showConfirmAccStatusModal, setShowConfirmAccStatusModal] = useState(false);
  const [pendingEmpAccStatus, setPendingEmpAccStatus] = useState('');
  const [showAccountStatusModal, setShowAccountStatusModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingList, setEditingList] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [role, setRole] = useState("");
  const [restEmployees, setRestEmployees] = useState([]);
  const [displayedEmployees, setDisplayedEmployees] = useState(restEmployees);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("firstName");
  const [direction, setDirection] = useState("asc");
  const [showEditRoleModal, setShowEditRoleModal] = useState(false);
  const [empEditRole, setEmpEditRole] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const canViewEmployee = useHasPermission("Employee-view");
  const canEditEmployee = useHasPermission("Employee-manage");
  const canViewEmployeeDetails = useHasPermission("Employee Details-view");
  const canEditEmployeeDetails = useHasPermission("Employee Details-manage");
  const canEditRole = useHasPermission("Update Role-manage");
  const canViewExport = useHasPermission("Export Employee Data-view");
  const canEditExport = useHasPermission("Export Employee Data-manage");

  useEffect(() => {
    setTotalItems(searchDataList?.totalItems)
    setTotalPages(searchDataList?.totalPages)
    // FIX: If backend sends page 0, we store it as 1 for our UI logic
    const backendPage = searchDataList?.pageNo ?? 0;
    setCurrentPage(backendPage === 0 ? 1 : backendPage + 1);
    setStatusCount(searchDataList?.statusCount)
    setRestEmployees(searchDataList?.result);
    setDisplayedEmployees(searchDataList?.result);
  }, [searchDataList]);

  useEffect(() => {
    if (canViewEmployee && currentPage === 1) {
      dispatch(fetchEmployeeList({ page: 1, SB: sortBy, order: direction, size: pageSize }));
    }
  }, [dispatch, canViewEmployee]);

  // useEffect(() => {
  //   if (searchTerm.trim() === "") {
  //     setTotalItems(employees?.totalItems);
  //     setTotalPages(employees?.totalPages);
  //     setCurrentPage((employees?.currentPage ?? 0) + 1);
  //     setStatusCount(employees?.statusCount);
  //     setRestEmployees(employees?.content);
  //     setDisplayedEmployees(employees?.content);
  //   }
  // }, [employees, totalPages, totalItems, currentPage, statusCount, searchTerm]);
  useEffect(() => {
    if (!searchTerm.trim()) {
      setTotalItems(employees?.totalItems ?? 0);
      setTotalPages(employees?.totalPages ?? 1);
      setCurrentPage((employees?.currentPage ?? 0) + 1);
      setStatusCount(employees?.statusCount ?? []);
      setRestEmployees(employees?.content ?? []);
      setDisplayedEmployees(employees?.content ?? []);
    }
  }, [employees, searchTerm]);

  useEffect(() => {
    if (!searchTerm || searchTerm.trim().length < 1) {
      return;
    }

    const timerId = setTimeout(() => {
      dispatch(
        fetchSearchData({
          type: "employee",
          keyword: searchTerm.trim(),
          page: 0,
          size: pageSize,
        }),
      );
    }, 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, [searchTerm, dispatch]);

  if (!canViewEmployee) {
    return (
      <p className="perm-msg">
        You don’t have permission to view employee page!
      </p>
    );
  }

  const restEmployee = restEmployees?.slice(1)?.filter((c) => c !== null);
  const filteredEmployeeData = restEmployee?.filter(
    (user) => user.joinedStatus === true,
  );

  const handleUpdateList = async (event) => {
    if (!canEditEmployee) {
      toast.error("You don't have permission to edit Employee details", {
        className: "toast-error-custom",
        autoClose: 5000,
      });
      return;
    }
    event.preventDefault();
    if (!editingList) return;

    try {
      const url = `${api.updateInviteCandidate}`;

      const updatedData = {
        firstName: firstName,
        middleName: middleName,
        lastName: lastName,
        roleName: role,
        email: emailId,
        mobile: mobileNo,
      };
      const response = await axiosPrivate.post(url, updatedData);
      if (response.status === 200) {
        toast.success("Details updated successfully", {
          className: "toast-success-custom",
        });
        setShowEditModal(false);
        setEditingList(null);
      }
    } catch (error) {
      toast.error(error?.message || "Server error during update", {
        className: "toast-error-custom",
      });
    }
  };
  const handleViewDetailsClick = (id) => {
    if (!canViewEmployeeDetails) {
      toast.error("You don't have permission to view employee details", {
        className: "toast-error-custom",
        autoClose: 5000,
      });
      return;
    }
    navigate(`/admin/employee/details/${id}`);
  };

  const renderTooltip = (props, description) => (
    <Tooltip id="button-tooltip" {...props}>
      {description}
    </Tooltip>
  );

  const formatLabel = (value) => {
    if (!value) return "";

    return value
      // permanentEmployees -> permanent Employees
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      // INFORMATION_TECHNOLOGY -> INFORMATION TECHNOLOGY
      .replace(/_/g, " ")
      // sabko lowercase karo
      .toLowerCase()
      // har word ka first letter capital
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handlePageChange = (_, value) => {
    if (canViewEmployee) {

      if (searchTerm.trim() === '') {
        dispatch(fetchEmployeeList({ page: value, SB: sortBy, order: direction, size: pageSize }));
      }
      else {
        // Add Math.max(0, ...) to prevent negative page numbers
        const targetPage = Math.max(0, value - 1);
        dispatch(fetchSearchData({ type: "employee", keyword: searchTerm.trim(), page: targetPage, size: pageSize }));
      }
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleInitialConfirmAccStatus = (selectedStatus) => {
    setPendingEmpAccStatus(selectedStatus);
    setShowAccountStatusModal(false);
    setShowConfirmAccStatusModal(true);
  };

  const handleEmpAccountStatusConfirm = (selectedStatusValue) => {
    if (!canEditEmployeeDetails) {
      handleFullCleanup();
      return;
    }
    if (!selectedEmpForAccStatus) return;

    dispatch(empAccountStatus({
      userId: selectedEmpForAccStatus.userId,
      status: selectedStatusValue
    })).then((result) => {
      // Only refresh list if the API call was successful
      if (result.meta.requestStatus === 'fulfilled') {
        if (searchTerm.trim() === '') {
          dispatch(fetchEmployeeList({ page: currentPage, SB: sortBy, order: direction, size: pageSize }));
        } else {
          dispatch(fetchSearchData({ type: "employee", keyword: searchTerm.trim(), page: currentPage, size: pageSize }));
        }
        setShowConfirmAccStatusModal(false);
        setSelectedEmpForAccStatus(null);
      }
    });
  };

  const handleFullCleanup = () => {
    setShowAccountStatusModal(false);
    setShowConfirmAccStatusModal(false);
    setSelectedEmpForAccStatus(null);
    if (resetEmpAccStatus) {
      dispatch(resetEmpAccStatus());
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      dispatch(
        fetchSearchData({
          type: "employee",
          keyword: searchTerm.trim(),
          page: 0,
          size: pageSize
        }),
      );
    }
  };

  const handleSortBy = (event) => {
    const selectedFilter = event.target.value;

    switch (selectedFilter) {
      case "Name":
        setSortBy("firstName");
        dispatch(
          fetchEmployeeList({ page: 1, SB: "firstName", order: direction, size: pageSize }),
        );
        break;
      // case "Role":
      //   setSortBy("roleName");
      //   dispatch(fetchEmployeeList({page:1,SB:"roleName",order:direction}));
      //   break;
      case "Email Id":
        setSortBy("email");
        dispatch(fetchEmployeeList({ page: 1, SB: "email", order: direction, size: pageSize }));
        break;

      case "Mobile No.":
        setSortBy("mobile");
        dispatch(
          fetchEmployeeList({ page: 1, SB: "mobile", order: direction, size: pageSize }),
        );
        break;

      default:
        break;
    }

    setDisplayedEmployees(employees?.content);
  };

  const handleOrderBy = (event) => {
    const selectedFilter = event.target.value;

    switch (selectedFilter) {
      case "Ascending":
        setDirection("asc");
        dispatch(fetchEmployeeList({ page: 1, SB: sortBy, order: "asc", size: pageSize }));
        break;

      case "Descending":
        setDirection("desc");
        dispatch(fetchEmployeeList({ page: 1, SB: sortBy, order: "desc", size: pageSize }));
        break;

      default:
        break;
    }

    setDisplayedEmployees(employees?.content);
  };
  const handleConfirmResend = () => {
    if (!canEditEmployee) {
      toast.error("You don't have permission to resend welcome mail", {
        className: "toast-error-custom",
        autoClose: 5000,
      });
      return;
    }
    if (selectedUserId) {
      dispatch(resendWelcomeMail(selectedUserId));
    }
    setShowConfirmModal(false);
    setSelectedUserId(null);
  };

  return (
    <div className="container-fluid" style={{ marginBottom: "30px" }}>
      <Breadcrumb />
      {/* employee list page */}
      <div className="section-body">
        <div className="container-fluid">
          <div className="tab-content">
            <div
              className="tab-pane fade active show"
              id="Employee-list"
              role="tabpanel"
            >
              <div className="card">
                <div className="card-header">
                  <div className="employeelist-header">
                    <div className="d-flex align-items-center "
                      style={{ gap: "10px" }}>
                      <div>
                        <h3 className="card-title mb-0">Sort By :</h3>
                      </div>
                      <div>
                        <form>
                          <div className="d-flex align-items-center ">
                            <select
                              className="custom-select"
                              onChange={handleOrderBy}
                            >
                              <option>Ascending</option>
                              <option>Descending </option>
                            </select>
                          </div>
                        </form>
                      </div>
                      <div>
                        <form>
                          <div className="d-flex align-items-center">
                            <select
                              className="custom-select"
                              onChange={handleSortBy}
                            >
                              <option>Name</option>
                              {/* <option>Role</option> */}
                              <option>Email Id</option>
                              <option>Mobile No.</option>
                            </select>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div>
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={(props) =>
                          renderTooltip(
                            props,
                            "Search by employee name or mob no.",
                          )
                        }
                      >
                        <form className="user-searchForm">
                          <input
                            className="form-control me-2 search"
                            type="search"
                            placeholder="Search employee"
                            aria-label="Search"
                            value={searchTerm}
                            onChange={handleInputChange}
                          />
                          <button
                            type="submit"
                            className="btn-interactive"
                            onClick={handleFormSubmit}
                            aria-label="Submit Search"
                          >
                            <ImSearch className="searchIcon" />
                          </button>
                        </form>
                      </OverlayTrigger>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                      <h3 className="card-title mb-0 ml-4 ">Page Limit:</h3>
                      <select
                        className="custom-select"
                        value={pageSize}
                        onChange={(e) => {
                          const value =
                            e.target.value === "all"
                              ? totalItems
                              : Number(e.target.value);

                          setPageSize(value);
                          setCurrentPage(1);
                          if (searchTerm.trim() === "") {
                            dispatch(
                              fetchEmployeeList({
                                page: 1,
                                SB: sortBy,
                                order: direction,
                                size: value,
                              })
                            );
                          } else {
                            dispatch(
                              fetchSearchData({
                                type: "employee",
                                keyword: searchTerm.trim(),
                                page: 0,
                                size: value,
                              })
                            );
                          }
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={40}>40</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value="all">All</option>
                      </select>
                    </div>
                  </div>
                  <div className="card-body">
                    {status === "loading" && (
                      <p className="loading">Loading...</p>
                    )}

                    {status === "failed" && (
                      <p className="server-error-msg">
                        Unable to connect to server
                      </p>
                    )}
                    {status == "succeeded" && (
                      <div className="user-table">
                        <table className="table table-hover table-vcenter text-nowrap mb-0">
                          <thead>
                            <tr>
                              <th className="name-column" style={{ width: "55px", textAlign: "center" }}>S.No.</th>
                              <th style={{ width: "100px" }}>Emp. ID</th>
                              <th>Name</th>
                              <th>Email ID</th>
                              <th style={{ width: "120px" }}>Mobile No.</th>
                              <th style={{ width: "120px" }}>Role</th>
                              <th style={{ width: "140px" }}>Emp Type</th>
                              <th style={{ width: "90px", textAlign: "center" }}>Status</th>
                              <th
                                ref={(el) => {
                                  if (el) {
                                    el.style.setProperty(
                                      "padding",
                                      "5px",
                                      "important",
                                    );
                                    el.style.setProperty("width", "65px");
                                    el.style.setProperty(
                                      "text-align",
                                      "center",
                                    );
                                  }
                                }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          {displayedEmployees?.length === 0 ? (
                            <p className="no-record-msg server-error-msg">-- No record found for employees --</p>
                          ) : (
                            <tbody>
                              {/* {displayedEmployees?.map((list, index) => { */}
                              {displayedEmployees
                                ?.filter((list) => list !== null && list !== undefined)
                                .map((list, index) => {
                                  //console.log("list:", list);
                                  const menuActions = [
                                    {
                                      label: "View",
                                      icon: require("assets/img/view-icon.png"),
                                      title: canViewEmployeeDetails ? "view" : "No permisssion to view employee",
                                      permission: canViewEmployeeDetails,
                                      onClick: () => handleViewDetailsClick(list?.userId),
                                      show: true,
                                    },
                                    {
                                      label: "Edit Role",
                                      icon: require("assets/img/edit-icon.png"),
                                      title: canEditRole ? "Edit role" : "No permisssion to edit role",
                                      permission: canEditRole,
                                      onClick: () => { setShowEditRoleModal(true); setEmpEditRole(list) },
                                      show: true,
                                    },
                                    {
                                      label: "Resend Welcome Mail",
                                      icon: require("assets/img/resend-link.png"),
                                      title: canViewEmployeeDetails ? "Resend welcome mail" : "No permisssion to resend welcome mail",
                                      permission: canViewEmployeeDetails,
                                      onClick: () => {
                                        setSelectedUserId(list.userId);
                                        setShowConfirmModal(true);
                                      },
                                      show: true,
                                    },
                                    {
                                      label: "Account Status",
                                      icon: require("assets/img/account-status-icon.png"),
                                      title: canEditEmployeeDetails ? "Account status" : "No permisssion to update account status",
                                      permission: canEditEmployeeDetails,
                                      iconStyle: { width: '20px', height: '20px' },
                                      onClick: () => { setSelectedEmpForAccStatus(list); setShowAccountStatusModal(true) },
                                      show: true,
                                    },
                                  ];
                                  return (
                                    <tr key={list.id ?? list.userId ?? `employee-${index}`} 
                                        role="gridcell"
                                        onClick={
                                          canViewEmployeeDetails
                                            ? () =>
                                              handleViewDetailsClick(
                                                list?.userId,
                                              )
                                            : undefined
                                        } style={{ cursor: canViewEmployeeDetails ? 'pointer' : 'default' }}>
                                      <td>{(pageSize * (currentPage - 1)) + index + 1}.</td>
                                      <td>{`${list?.employeeId ?? "-"}`}</td>
                                      <td>{list?.fullName ?? "-"}
                                      </td>
                                      {/* <td className="email-column">
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip id={`email-tooltip-${list.userId}`}>
                                              {list?.email ?? "-"}
                                              {console.log("list?.email:", list?.email)}
                                            </Tooltip>
                                          }
                                        >
                                          <span style={{ cursor: 'pointer' }}>
                                            {list?.email ?? "-"}
                                          </span>
                                        </OverlayTrigger>
                                      </td> */}
                                      <td className="email-column">
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip id={`email-tooltip-${list.userId ?? index}`}>
                                              {list.email ?? "-"}
                                            </Tooltip>
                                          }
                                        >
                                          <span style={{ cursor: "pointer" }}>
                                            {list.email ?? "-"}
                                          </span>
                                        </OverlayTrigger>
                                      </td>
                                      <td>{list?.mobile ?? "-"}</td>
                                      <td>{list?.roleName ?? "-"}</td>
                                      <td>{formatLabel(list?.empType ?? "-")}</td>
                                      <td>{formatLabel(list?.accountStatus ?? "-")}</td>
                                      <td className="action-column">
                                        <PopupState
                                          variant="popover"
                                          popupId="demo-popup-menu"
                                        >
                                          {(popupState) => (
                                            <>
                                              <button
                                                type="button"
                                                className="btn btn-icon btn-sm icons"
                                                {...bindTrigger(popupState)}
                                              >
                                                <img
                                                  src={require("assets/img/more.png")}
                                                  alt="more"
                                                  className="action-icon"
                                                  style={{
                                                    opacity: canViewEmployeeDetails
                                                      ? 1
                                                      : 0.5,
                                                  }}
                                                />
                                              </button>

                                              <Menu {...bindMenu(popupState)}>
                                                {menuActions
                                                  .filter(
                                                    (action) => action.show,
                                                  )
                                                  .map((action, index) => (
                                                    <MenuItem
                                                      key={index}
                                                      title={action.title}
                                                      disabled={
                                                        !action.permission
                                                      }
                                                      onClick={() => {
                                                        popupState.close();
                                                        if (action.permission)
                                                          action.onClick();
                                                      }}
                                                      style={{
                                                        pointerEvents: 'auto',
                                                        cursor: action.permission ? 'pointer' : 'not-allowed'
                                                      }}
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-icon btn-sm icons me-2"
                                                        disabled={
                                                          !action.permission
                                                        }
                                                        style={{ pointerEvents: !action.permission ? 'none' : 'auto' }}
                                                      >
                                                        <img
                                                          src={action.icon}
                                                          alt={action.label}
                                                          className="action-icon"
                                                          style={{
                                                            opacity:
                                                              action.permission
                                                                ? 1
                                                                : 0.5,
                                                            ...action.iconStyle
                                                          }}
                                                        />
                                                      </button>
                                                      {action.label}
                                                    </MenuItem>
                                                  ))}
                                              </Menu>
                                            </>
                                          )}
                                        </PopupState>
                                      </td>
                                    </tr>
                                  )
                                })}
                            </tbody>
                          )
                          }
                        </table>

                        <Stack
                          spacing={2}
                          sx={{ marginTop: 3, alignItems: "center" }}
                        >
                          <Pagination
                            count={Math.max(1, totalPages || 1)}
                            page={
                              Number.isInteger(currentPage) && currentPage >= 1
                                ? currentPage
                                : 1
                            }
                            onChange={handlePageChange}
                            shape="rounded"
                            color="primary"
                            disabled={status === "loading"}
                          />
                        </Stack>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {canEditRole && (
        <EditRoleModal
          show={showEditRoleModal}
          canEdit={canEditRole}
          onHide={() => setShowEditRoleModal(false)}
          setShowEditRoleModal={setShowEditRoleModal}
          employeeData={empEditRole}
          onUpdate={updateEmployeeRole}
        />)}

      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
      >
        <Modal.Header>
          <Modal.Title className="d-flex align-items-center mb-0">
            Confirm Resend Welcome Mail
          </Modal.Title>
          <button
            onClick={() => setShowConfirmModal(false)}
            className="modal-close"
            aria-label="Close"
          >
            <img
              src={CrossIcon}
              alt="Close"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-0">
            Are you sure you want to resend the welcome email to this employee?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="cancel-cta"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button variant="update-cta" onClick={handleConfirmResend}>
            Yes, Resend Mail
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header>
          <Modal.Title>Edit List</Modal.Title>
          <button
            onClick={() => setShowEditModal(false)}
            className="modal-close"
          >
            <img
              src={CrossIcon}
              alt="Close"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleUpdateList}>
            <Form.Group className="mb-3">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Middle Name</Form.Label>
              <Form.Control
                type="text"
                value={middleName}
                onChange={(e) => setMiddleName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Role</Form.Label>
              <Form.Control
                type="text"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email Id</Form.Label>
              <Form.Control
                type="email"
                value={emailId}
                onChange={(e) => setEmailId(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Mobile No.</Form.Label>
              <Form.Control
                type="text"
                value={mobileNo}
                onChange={(e) => setMobileNo(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="cancel-cta" onClick={() => setShowEditModal(false)}>
            Close
          </Button>
          <Button
            variant="update-cta"
            onClick={canEditEmployee ? handleUpdateList : undefined}
            disabled={!canEditEmployee}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      {canEditEmployeeDetails && (
        <>
          <EditEmpAccountStatusModal
            show={showAccountStatusModal}
            canEdit={canEditEmployeeDetails}
            onHide={handleFullCleanup}
            currentStatus={selectedEmpForAccStatus?.accountStatus === "ACTIVE" ? 'active' : 'inactive'}
            onConfirm={handleInitialConfirmAccStatus}
          />
          <ConfirmAccStatusModal
            show={showConfirmAccStatusModal}
            canEdit={canEditEmployeeDetails}
            onHide={handleFullCleanup}
            onConfirm={() => handleEmpAccountStatusConfirm(pendingEmpAccStatus)}
            title="Confirm Account Status"
            message={
              <>
                Are you sure you want to change the status of{" "}
                <strong>{selectedEmpForAccStatus?.fullName}</strong> to{" "}
                <strong>{pendingEmpAccStatus}</strong>?
              </>
            }
          />
        </>
      )}
      <ToastContainer />
    </div>
  );
}
